import React, { Component } from "react";

import styles from "./IncomeIdentifier.module.sass";

import Title from "../Title/Title";
import Input from "../ui/Input/Input";
import Tooltip from "../ui/Tooltip/Tooltip";

import Button from "../ui/Button/Button";
import { inputType } from "../ui/Input/Input";
import currency from "../../utils/currency";
import gaTags from "./../../utils/ga-tags";
const notSpecified =  "Não Especificada"
export class IncomeIdentifier extends Component {
  targetDiv = React.createRef();

  state = {
    incomeValue: "0,00",
    partnerIncome: "0,00",
    hasPartner: false
  };

  hasPartnerHandler = event => {
    window.dataLayer.push({
      event: "datalayereventos",
      gacategory:
        event.target.getAttribute("data-gacategory") || notSpecified,
      gatype: event.target.getAttribute("data-gatype") || notSpecified,
      gafunc: event.target.getAttribute("data-gafunc") || notSpecified
    });
    if (this.props.hasOwnProperty("onClick")){
      this.props.onClick(event);
    }
    this.setState({
      hasPartner: !this.state.hasPartner
    });
  };

  checkValidity = () => {
    if (currency.currencyToNumber(this.state.incomeValue)) {
      if (
        this.state.hasPartner &&
        currency.currencyToNumber(this.state.partnerIncome) > 0
      ) {
        return true;
      } else if (!this.state.hasPartner) {
        return true;
      }
    }
    return false;
  };

  onConfirmHandler = () => {
    this.props.onConfirm({
      primaryValue: currency.currencyToNumber(this.state.incomeValue),
      secondaryValue: currency.currencyToNumber(this.state.partnerIncome)
    });
  };

  scrollToDiv = () => {
    this.targetDiv.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  render(props) {
    const typePerson =
      this.props.typeDocument === "cpf" ? "pessoafisica" : "pessoajuridica";
    const gaTypeName = `${gaTags.type}&${typePerson}&-&${this.state.incomeValue}&-`;

    return (
      <div
        ref={el => {
          this.targetDiv = el;
        }}
        className={styles.IncomeIdentifierDetail}
      >
        <Title
          title={
            this.props.typeDocument === "cpf"
              ? "Também precisamos saber sua renda mensal"
              : "Também precisamos saber o faturamento médio da empresa"
          }
          tooltip={
            this.props.typeDocument === "cpf" ? (
              <Tooltip>
                <p>
                  <b>
                    Antes de continuar, temos algo importante para te lembrar.
                  </b>
                </p>
                <p>
                  Ao começar um consórcio é ideal ter uma renda mensal 3x maior
                  que a parcela escolhida. Por exemplo, se o consórcio escolhido
                  tiver uma parcela de R$ 600,00, é interessante ter uma renda
                  mensal de pelo menos R$ 1.800,00. E lembre-se que ao ser
                  contemplado(a), será preciso comprovar a renda informada.
                </p>
              </Tooltip>
            ) : (
              <Tooltip>
                <p>
                  <b>
                    Antes de continuar, temos algo importante para te lembrar.
                  </b>
                </p>
                <p>
                  Ao começar um consórcio é ideal ter um faturamento mensal 3x
                  maior que a parcela escolhida. Por exemplo, se o consórcio
                  escolhido tiver uma parcela de R$ 600,00, é interessante ter
                  um faturamento de pelo menos R$ 1.800,00. E lembre-se que ao
                  ser contemplado(a), será preciso comprovar o faturamento
                  informado.
                </p>
              </Tooltip>
            )
          }
        />
        <div className={styles.content}>
          <Input
            valid={currency.currencyToNumber(this.state.incomeValue) > 0}
            type={inputType.CURRENCY}
            onChange={value => this.setState({ incomeValue: value })}
            value={this.state.incomeValue}
            onKeyPress={event => {
              return event.key === "Enter" && this.onConfirmHandler();
            }}
          />
        </div>

        {this.props.typeDocument === "cpf" &&
        this.state.hasPartner === false ? (
          <div className={styles.partnerIncome}>
            <span
              className={[styles.detailsLink, "ga-eventos"].join(" ")}
              data-gacategory={gaTags.categoryDefault}
              data-gatype={`${gaTypeName}DadosPessoais`}
              data-gafunc={`${gaTypeName}TXT.ComplementarRenda`}
              onClick={this.hasPartnerHandler}
            >
              Quero somar essa renda com a renda do meu cônjuge.
            </span>
            <Tooltip>
              <p>
                Caso a sua renda não seja suficiente para a compra do consórcio,
                você pode complementar com a renda do(a) seu(sua) cônjuge.{" "}
              </p>
              <p> Válido para casamento e união estável.</p>
            </Tooltip>
          </div>
        ) : null}

        {this.state.hasPartner ? (
          <div className={styles.partnerIncome}>
            <Title title="Renda do Cônjuge" />
            <span
              role="link"
              onClick={this.hasPartnerHandler}
              className={styles.link}
            >
              Cancelar
            </span>
            <div className={styles.content}>
              <Input
                valid={currency.currencyToNumber(this.state.partnerIncome) > 0}
                type={inputType.CURRENCY}
                onChange={value => this.setState({ partnerIncome: value })}
                value={this.state.partnerIncome}
                onKeyPress={event => {
                  return event.key === "Enter" && this.onConfirmHandler();
                }}
              />
            </div>
          </div>
        ) : null}
        <div className={styles.divider} />
        <Button
          onClick={this.onConfirmHandler}
          selected
          disabled={!this.checkValidity()}
          data-gacategory={gaTags.categoryDefault}
          data-gatype={
            !this.state.hasPartner
              ? `${gaTypeName}DadosPessoais`
              : `${gaTypeName}${this.state.partnerIncome}DadosPessoais`
          }
          data-gafunc={
            !this.state.hasPartner
              ? `${gaTypeName}TXT.Comprar`
              : `${gaTypeName}${this.state.partnerIncome}TXT.Comprar`
          }
        >
          {" "}
          Comprar{" "}
        </Button>
      </div>
    );
  }
}

export default IncomeIdentifier;
